import { Port } from '@/store/bricks/models';

/**
 *
 * Copyright (c) 2019-present, wobe-systems GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * to be found in the LICENSE file in the root directory of this source tree.
 */

import draw2d from 'draw2d';

function schemaToMap(schema: string) {
  const map: any = {};
  // Check if the port has an existing Schema
  // attempt to extract information out of it
  if (schema) {
    const schemaArr : any = schema.split(';');
    schemaArr.forEach((element: string) => {
      if (element.length > 0) {
        const s = element.split(' = ');
        // eslint-disable-next-line
        map[s[0].replace(/\s+/g, '')] = s[1];
      }
    });
  }
  return map;
}

export function iterateAll(data: any): {result: any} {
  const result : any = [];
  for (const i in data) {
    // eslint-disable-next-line no-use-before-define
    const treeViewItem: any = makeTreeviewItem(data[i]);
    result.push(treeViewItem[0]);
  }

  return result;
}

export function makeTreeviewItem(data: any): {treeviewItem: any} {
  const treeviewItem: any = [];
  const obj = { name: `${data.name} (${data.type.toString()})`, children: iterateAll(data.elements) };
  treeviewItem.push(obj);

  return treeviewItem;
}

function drawPorts(
  x: number, type: string,
  ports: Port[],
  _this: any,
  brickData: any = {},
) {
  const noPorts = ports.length;

  for (const i in ports) {
    const port = ports[i];
    const y = (100 / (noPorts + 1)) * (Number(i) + 1);
    const newport: any = _this.createPort(
      port.name,
      type,
      new draw2d.layout.locator.XYRelPortLocator(x, y),
    );
    const color: string = '#F0F3F3';
    newport.setConnectionDirection();
    newport.setBackgroundColor(color);
    newport.setName(port.name);
    newport.setId(port.name);
    newport.setMaxFanOut(20);
    newport.setRadius(7);

    const typeDef: any = makeTreeviewItem(port.populatedJSON);
    const typeDoc = port.populatedJSON.doc; // use doc from the root object

    newport.setUserData({
      portData: {
        name: port.name,
        dataTypeName: port.typeName,
        type,
        typeDef,
        typeDoc,
        json: port.JSONSchema,
        schema: port.schema,
        populatedJSON: port.populatedJSON,
      },
      brickData,
    });

    newport.addCssClass('draw2d_port');

    newport.onClick = () => {
      _this.canvas.fireEvent('onClickPort', { newport });
    };

    newport.on('disconnect', (emitterPort: any, connection: any) => {
      _this.canvas.fireEvent('onDisconnectPort', { connection });
    });

    newport.on('connect', (emitterPort: any, connection: any) => {
      _this.canvas.fireEvent('onConnectPort', { connection });
    });
  }
}

export default function addPorts(_this: any, brickData: any = {}) {
  // add input ports
  if (brickData.inputPorts) {
    drawPorts(0, 'input',
      brickData.inputPorts,
      _this,
      brickData);
  }
  // add output ports
  if (brickData.outputPorts) {
    drawPorts(100, 'output',
      brickData.outputPorts,
      _this,
      brickData);
  }
}
